export const CONSENT_GOVERNANCE_FEATURE_SWITCH = "FS-consent-governance" as const;
